import { render, staticRenderFns } from "./ATSPostingStatus.vue?vue&type=template&id=53314db6"
import script from "./ATSPostingStatus.vue?vue&type=script&lang=js"
export * from "./ATSPostingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports